/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { Cookies } from 'react-cookie';

export const cookies = new Cookies();
export const DeserializeBase64EncodedJSONCookie = <T>(stringifiedCookieBase64: string): T => {
  return JSON.parse(Buffer.from(stringifiedCookieBase64, 'base64').toString()) as T;
};

export const getParsedCookieValue = (cookieName: string): string | undefined => {
  const cookie = cookies.get(cookieName);
  const parsedCookie = cookie && cookie.slice(2, cookie.indexOf('.'));
  return parsedCookie;
};

export const getCookieValue = (cookieName: string): string | undefined => {
  return cookies.get(cookieName);
};
